import React from "react";
import { Typography, Card, CardContent } from "@mui/material";

function Location() {
  const serviceTimes = [
    { day: "Miércoles", time: "7pm - 8:30pm" },
    { day: "Viernes", time: "7pm - 9pm" },
    { day: "Domingo", time: "9am - 12pm" },
  ];

  return (
    <>
      <section
        className="page-section"
        style={{
          color: "var(--text-color)",
          height: "100vh",
          backgroundColor: "var(--background-white-color)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "3rem",
              textAlign: "center",
            }}
          >
            <div>
              <Typography variant="h2" gutterBottom>
                Horarios de cultos
              </Typography>
              <Typography
                variant="body1"
                style={{ maxWidth: "600px" }}
              >
                Únete a nosotros en estos horarios especiales para compartir la
                palabra de Dios
              </Typography>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "2rem",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {serviceTimes.map((service, index) => (
                <Card
                  key={index}
                  style={{
                    minWidth: "250px",
                    maxWidth: "300px",
                    backgroundColor: "var(--accent-color)",
                    color: "var(--background-white-color)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <CardContent style={{ padding: "2rem", textAlign: "center" }}>
                    <Typography variant="h4" gutterBottom>
                      {service.day}
                    </Typography>
                    <Typography
                      variant="h5"
                      style={{
                        marginBottom: "1rem",
                        fontWeight: "bold",
                      }}
                    >
                      {service.time}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Google Map Container using iframe */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d402.3807270232389!2d-79.51582901303757!3d9.037799842468933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8faca94436c0ec5f%3A0xce51cd32f37dd8c9!2siglesia%20evangelica%20de%20la%20fe.%20As.%20de%20Dios!5e0!3m2!1sen!2sus!4v1773017431970!5m2!1sen!2sus"
        style={{
          border: 0,
          width: "100%",
          height: "50vh",
        }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </>
  );
}

export default Location;
